import { Router } from 'synergy/models';
const { UPDATE_OR_CREATE } = Router.types;

export function setRouter(data) {
  return {
    type: UPDATE_OR_CREATE,
    payload: data
  };
}
